import React, { ReactElement } from 'react';

import ViewWrapper from 'components/core/Layout/ViewWrapper';
import { withProcessesData } from 'components/common/withProcessesData';
import { ChartDetailsContext } from 'charts/context/chartDetailsContext';
import { MemoChartDetails } from './chartDetails';
import { MemoAnalyticsDashboard } from './dashboard';
import { useSyncIssuesOnMount } from 'hooks/useSyncIssuesOnMount';

interface AnalyticsParams {
  id: string;
}

function Analytics({ id }: AnalyticsParams): ReactElement {
  //TODO https://hustro.atlassian.net/browse/PT-2401
  useSyncIssuesOnMount();
  const isDetailsView = id !== undefined;

  return (
    <ChartDetailsContext.Provider value={isDetailsView}>
      <ViewWrapper>
        {isDetailsView ? (
          <MemoChartDetails id={id} />
        ) : (
          <MemoAnalyticsDashboard />
        )}
      </ViewWrapper>
    </ChartDetailsContext.Provider>
  );
}

export const MemoAnalytics = React.memo(
  withProcessesData(Analytics)
);
